<template>
  <tr>
    <td>{{ nombreTipoCuota(modificador.tipoCuota) }}</td>
    <td>
      <b-form-input
        type="number"
        v-model="modificadorEditado.porcentajeModificadorPrecio"
        v-show="editando"
        ref="campo"
        min="0.000000000000"
        max="200"
        step="0.01"
        @keypress.enter="guardar"
      />
      <span v-show="!editando"> {{ modificador.porcentajeModificadorPrecio }}% </span>
    </td>
    <td nowrap class="text-center">
      <b-button variant="primary" size="sm" @click="editar" v-show="!editando">
        <v-icon name="edit" width="16" /> Editar
      </b-button>
      <b-button-group v-show="editando">
        <b-button variant="secondary" size="sm" @click="cancelar"> <v-icon name="x" width="16" /> Cancelar </b-button>
        <b-button variant="success" size="sm" @click="guardar"> <v-icon name="check" width="16" /> Guardar </b-button>
      </b-button-group>
      <span v-show="!editando">
        |
        <b-button variant="danger" size="sm" @click="eliminar"> <v-icon name="trash" width="16" /> Eliminar </b-button>
      </span>
    </td>
  </tr>
</template>

<script>
import { useModificadorPrecioModuloStore } from "@/stores/ModificadorPrecioModuloStore";
import { mapState } from "pinia";
import { nombreTipoCuota } from "@/enums/TipoCuota";

export default {
  props: {
    modificador: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modificadorEditado: {
        id: this.modificador.id,
        duracionContratoId: this.modificador.duracionContratoId,
        tipoCuota: this.modificador.tipoCuota,
        porcentajeModificadorPrecio: this.modificador.porcentajeModificadorPrecio,
      },
      editando: false,
    };
  },
  computed: {
    ...mapState(useModificadorPrecioModuloStore, ["comboTiposDeCuota"]),
  },
  methods: {
    nombreTipoCuota(tipo) {
      return nombreTipoCuota(tipo);
    },
    editar() {
      this.modificadorEditado = {
        id: this.modificador.id,
        duracionContratoId: this.modificador.duracionContratoId,
        tipoCuota: this.modificador.tipoCuota,
        porcentajeModificadorPrecio: this.modificador.porcentajeModificadorPrecio,
      };
      this.editando = true;
      this.$nextTick(() => {
        const campo = this.$refs.campo;
        campo.focus();
        campo.select();
      });
    },
    async eliminar() {
      const ok = this.$messages.confirm("¿Desea eliminar el descuento?");
      if (ok) {
        const store = useModificadorPrecioModuloStore();
        await store.eliminarModificador(this.modificador.id);
        this.$messages.info("Se ha eliminado el descuento");
      }
    },
    async guardar() {
      const store = useModificadorPrecioModuloStore();
      await store.guardarModificador(this.modificadorEditado);
      this.$messages.success("Descuento guardado");
      this.editando = false;
    },
    cancelar() {
      this.editando = false;
    },
  },
};
</script>
